module.exports = __webpack_public_path__ + "img/climatescience.0fd6c867.png";